import React from 'react';
import '../App.css';
import { Headerapp } from './/headerapp'
import { Bodyappresetpassbody} from './/bodyappresetpassbody'
import { Footerapp } from './/footerapp'

export class Bodyapparesetpass extends React.Component {
  constructor(props){
    super (props);
  }

  render(){
    return (
      <div className="App">        
        <Headerapp/>
        <Bodyappresetpassbody/>
        <Footerapp/>
      </div>
    );
  }
}